import React, { useState } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import SettingColumn from '../SettingColumn/SettingColumn';
import { Icons } from '../BootstrapComponents/BootstrapComponents';
import { useStoreState } from '../../../utils/utils';
import ContextMenu from '../ContextMenu/ContextMenu';
import './GridStyles.scss';

export default function PropertyGrid(props) {
  const {
    name,
    columns = [],
    additionalColumns = [],
    renderContextMenu = () => {},
    onClickByRow = () => {},
    rowClassFormatter = () => {},
    data = [],
    onDoubleClickByRow = () => {},
  } = props;

  const onSelectRow = (item, index) => event => {
    onClickByRow(item, event, index);
  };

  const [contextItem, setContextItem] = useState(null);
  const [contextEvent, setContextEvent] = useState(null);
  const [isOpen, setOpen] = useState(false);

  const { formatMessage } = useIntl();
  const handleContextMenu = (item, event) => {
    setContextItem(item);
    setContextEvent(event);
    event.stopPropagation();
    event.preventDefault();
  };

  const hideContextMenu = () => {
    setContextItem(null);
    setContextEvent(null);
  };

  const onDoubleSelectRow = (item, index) => event => {
    onDoubleClickByRow(item, event, index);
  };

  const availableColumns = [...columns].map((e, i) => ({ ...e, id: `${name}-column-${i}` }));
  const addColumns = additionalColumns.map((e, i) => ({ ...e, id: `${name}-column-${i + availableColumns.length}` }));
  const allColumns = [...availableColumns, ...addColumns];
  const initial = availableColumns.reduce((acc, cur) => { acc[cur.id] = true; return acc; }, {});
  const [visibleColumns, setVisibleColumns, resetVisible, saveVisible] = useStoreState(initial, name);
  const [columnsOrder, setColumnsOrder, resetOrder, saveOrder] = useStoreState(allColumns.map(c => c.id), `${name}-order`);
  const rows = allColumns.filter(c => visibleColumns[c.id]).sort((a, b) => (columnsOrder.indexOf(a.id) - columnsOrder.indexOf(b.id)));

  const renderRow = (row, index, item) => {
    const {
      headerStyle = {}, headerClassName, headerCallback = () => {}, bodyStyle = {}, dataClassName = '',
    } = row;
    let content = '';
    if (row.headerFormatter && typeof row.headerFormatter === 'function') {
      content = row.headerFormatter(content, row);
    } else {
      content = formatMessage({ id: row.text || row.dataField, defaultMessage: row.text || ' ' });
    }

    let fieldContent = item[row.dataField];
    if (row.formatter && typeof row.formatter === 'function') {
      fieldContent = row.formatter(fieldContent, row, index);
    }
    return (
      <tr key={index} className="data-table-row">
        <td className="data-table-cell data-table-label">
          {content}
        </td>
        <td className="data-table-cell  data-table-value">
          <div className="data-table-value-wrapper">
            {fieldContent}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <div className="property-grid">
        {data && data.map((item, key) => (
          <div
            key={key}
            className={classNames('property-grid-item', rowClassFormatter(item, key))}
            onContextMenu={event => handleContextMenu(item, event)}
            onClick={onSelectRow(item, key)}
            onDoubleClick={onDoubleSelectRow(item, key)}
          >
            <table className="property-table-content">
              <tbody>
                {rows && rows.map((row, rowKey) => renderRow(row, rowKey, item))}
                <tr className="data-table-row">
                  <td className="data-table-cell data-table-settings" colSpan={2}>
                    <div className="property-settings">
                      <div className="spacer" />
                      <div onClick={event => handleContextMenu(item, event)}>Действия</div>
                      <div className="button-icon-block">
                        <Icons onClick={() => setOpen(true)} width={24} height={24} customIcon icon="gear" className="button-icons ms-auto" />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ))}
      </div>
      <SettingColumn
        open={isOpen}
        lockOnPopup
        availableColumns={allColumns}
        setVisibleColumns={setVisibleColumns}
        visibleColumns={visibleColumns}
        setColumnsOrder={setColumnsOrder}
        columnsOrder={columnsOrder}
        resetVisible={resetVisible}
        resetOrder={resetOrder}
        saveVisible={saveVisible}
        saveOrder={saveOrder}
        addColumns={addColumns}
        onHide={() => { setOpen(false); }}
      />

      {contextEvent && contextItem ? <ContextMenu item={contextItem} event={contextEvent} renderContextMenu={renderContextMenu} onClose={hideContextMenu} /> : null}
    </>
  );
}
